export default "__VITE_ASSET__CO$waqep__"